<template>
  <div id="Informacje">
    <div id="info-brak-miejsca" class="bgInfo" v-if="errors.brak_szafy">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-exclamation-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
        </svg> - {{$t('message.ilosc_urzadzen_poza_szafa')}}
      </span>
    </div>
    <div id="info-brak-miejsca" class="bgInfo" v-if="errors.brak_miejsca">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-exclamation-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
        </svg> - {{$t('message.brak_miejsca_na_urzadzenia')}}
      </span>
    </div>
    <div id="info-brak-miejsca" class="bgInfo" v-if="errors.brak_akumulatora">
      <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-exclamation-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
        </svg> - {{$t('message.brak_akumulatora_w_konfiguracji')}}
      </span>
    </div>
    <div id="info-glebokosc-szafy" class="bgInfo" v-if="inputs.glebokosc_szafy.active">
      <button @click="changeDepth()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-x-square-fill" viewBox="0 0 16 16">
          <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm3.354 4.646L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708z"/>
        </svg> - {{$t('message.przywroc_glebokosc_szafy')}}
      </button>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { calculation } from '../mixins/calculation'

export default {
  name: 'Informacje',
  mixins: [app, calculation],
  data () {
    return {

    }
  },
  watch: {
    errors: {
      deep: true, // <!-- This is important;
      handler (newValue) {
        if (newValue.brak_szafy) {
          this.changeInfoTime('brak_szafy')
        }
        if (newValue.brak_akumulatora) {
          this.changeInfoTime('brak_akumulatora')
        }
      }
    }
  },
  computed: {
    ...mapGetters('app', ['dialogInfo']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('app', ['errors'])
  },
  methods: {
    changeDepth () {
      this.changeValueInputs('glebokosc_szafy', 'active', false)
    },
    changeInfoTime (val) {
      var self = this
      setTimeout(function () { self.$store.commit('app/SET_ERROR_INFO', [val, false]) }, 3000)
    }
  }
}
</script>

<style scoped>
#Informacje {
  font-size: 18px;
}
.bgInfo {
  width: 100%;
  text-align: left;
  padding: 5px;
  background: #fff;
  color: white;
}
#info-glebokosc-szafy button {
  color: red;
  background: none;
  border:none;
  cursor: pointer;
  font-weight: 600;
}
#info-brak-miejsca span {
  color: blue;
  background: none;
  border:none;
  margin-left: 8px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/Information.vue